import {Subscription} from 'rxjs';
// Angular
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, ChangeDetectorRef, ApplicationRef} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
// Layout
import {LayoutConfigService, SplashScreenService, TranslationService} from './core/_base/layout';
// language list
import {locale as enLang} from './core/_config/i18n/en';
import {locale as chLang} from './core/_config/i18n/ch';
import {locale as esLang} from './core/_config/i18n/es';
import {locale as jpLang} from './core/_config/i18n/jp';
import {locale as deLang} from './core/_config/i18n/de';
import {locale as frLang} from './core/_config/i18n/fr';
import {locale as trLang} from './core/_config/i18n/tr';
import {SignalRService} from './mbs/services/signalR/signal-r.service';
import {LoadingService} from './mbs/services/loading/loading.service';
import {SwUpdate} from '@angular/service-worker';
import {first, switchMap} from 'rxjs/operators';
import {Logout} from './core/auth';
import {AppState} from './core/reducers';
import {Store} from '@ngrx/store';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'body[kt-root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
    // Public properties
    title = 'Mezun Bilgi Sistemi';
    loader: boolean;
    loading: boolean;
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

    /**
     * Component constructor
     *
     * @param applicationRef: ApplicationRef
     * @param swUpdate: SwUpdate
     * @param cdr: ChangeDetectorRef
     * @param translationService: TranslationService
     * @param router: Router
     * @param layoutConfigService: LayoutCongifService
     * @param splashScreenService: SplashScreenService
     * @param loadingService: LoadingService
     * @param signalRService: SignalRService
     * @param store: Store<AppState>
     */
    constructor(
        private applicationRef: ApplicationRef,
        private swUpdate: SwUpdate,
        private cdr: ChangeDetectorRef,
        private translationService: TranslationService,
        private router: Router,
        private layoutConfigService: LayoutConfigService,
        private splashScreenService: SplashScreenService,
        private loadingService: LoadingService,
        private signalRService: SignalRService,
        private store: Store<AppState>
    ) {
        // register translations
        this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang, trLang);

        if (this.swUpdate.isEnabled) {
            this.applicationRef.isStable.pipe(first(isStable => isStable === true),
                switchMap(() => this.swUpdate.available)).subscribe(() => {
                this.swUpdate.activateUpdate().then(() => {
                    console.log('Uygulama güncellendi.');
                    setTimeout(() => {
                        document.location.reload();
                    }, 3000);
                });
            });
        }
    }

    ngOnInit(): void {
        // enable/disable loader
        this.loader = this.layoutConfigService.getConfig('loader.enabled');

        this.loadingService.loading$.subscribe((status: boolean) => {
            this.loading = status;
            this.cdr.detectChanges();
        });

        this.signalRService.buildStatisticConnection();
        this.signalRService.startStatisticConnection();

        this.signalRService.receivedLogoutUser.subscribe(() => {
            this.store.dispatch(new Logout());
        });

        this.signalRService.receivedReloadUserBrowser.subscribe(() => {
            document.location.reload();
        });

        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {

                const currentRouteUrl = this.router.url.split(/[?#]/)[0];
                this.signalRService.changeLocation(currentRouteUrl);

                // hide splash screen
                this.splashScreenService.hide();

                // scroll to top on every route change
                window.scrollTo(0, 0);

                // to display back the body content
                setTimeout(() => {
                    document.body.classList.add('kt-page--loaded');
                }, 500);
            }
        });
        this.unsubscribe.push(routerSubscription);
    }

    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
}
